// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"fcbffe4d","583":"e591c597","983":"f29d57a9"}[chunkId] + ".chunk.js";
};